import React, { useState } from "react";
import getModalStyle from "../../../util/getModalStyle";
import { addKD, removeKD } from "../../../api/SidebarApi";
import { useQueryClient } from "react-query";

function useKdSelector(
  quoteId: string,
  unitId: string,
  doorType: string,
  kd: boolean
) {
  const queryClient = useQueryClient();

  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const handleKD = async () => {
    if (!quoteId || !unitId || doorType === "Swing") return;

    const res = !kd
      ? await addKD(quoteId, unitId)
      : await removeKD(quoteId, unitId);

    if (res.data === "added") {
      return queryClient.invalidateQueries("QuoteCart");
    }
  };

  return {
    modalStyle,
    handleKD,
  };
}

export default useKdSelector;
